import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import {
  Select,
  Row, Col, DatePicker, Modal, Button, Card,
} from 'antd';
import Merchants from './index';

const { Option } = Select;
const { RangePicker } = DatePicker;

const TransactionSummary = ({
  wallet,
  isAffiliate,
  summary,
  summaryLoading,
  handleChange,
}) => {
  const [visibleSelectChildMerchantModal, setVisibleSelectChildMerchantModal] = useState(false);
  const [selectedChildMerchant, setSelectedChildMerchant] = useState(null);
  const [selectedTransactionStatus, setSelectedTransactionStatus] = useState(null);

  const selectChildMerchant = () => {
    setVisibleSelectChildMerchantModal(true);
  };

  const closeSelectChildMerchantModal = () => {
    setVisibleSelectChildMerchantModal(false);
  };

  const OkSelectChildMerchantModal = (childMerchant) => {
    if (childMerchant) {
      setSelectedChildMerchant(childMerchant);
      handleChange(childMerchant._id, 'child_merchant');
    }
    setVisibleSelectChildMerchantModal(false);
  };

  const onTransactionStatusChanged = (e) => {
    setSelectedTransactionStatus(e);
    handleChange(e, 'transaction_status');
  };

  const transactionStatusOptions = [
    'COMPLETED', 'FAILED', 'CANCELLED', 'PENDING', 'PROCESSING',
  ].map((transactionStatus) => (
    <Option key={transactionStatus} value={transactionStatus}>
      {transactionStatus}
    </Option>
  ));

  const colSize = isAffiliate ? 6 : 8;
  const selectedTransactionType = 'COLLECTION';

  let ledgerAmountDescription = selectedTransactionType;
  if (!isAffiliate) {
    ledgerAmountDescription = (selectedTransactionType === 'COLLECTION') ? 'CREDIT' : 'DEBIT';
  }

  return (
    <>
      <Row>
        <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24}>
          <RangePicker onChange={(_, dateString) => handleChange(dateString, 'date_range')} style={{ width: '100%' }} />
        </Col>
        <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24} />
        <Col xl={colSize} lg={colSize} md={colSize} sm={colSize} xs={24}>
          <Select
            allowClear
            showArrow
            style={{ width: '100%' }}
            placeholder="Transaction Status"
            onChange={(e) => onTransactionStatusChanged(e)}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase()
              .indexOf(input.toLowerCase()) >= 0}
          >
            {transactionStatusOptions}
          </Select>
        </Col>

        {isAffiliate
        && (
          <>
            <Col xl={8} lg={8} md={8} sm={8} xs={24}>
              <Button style={{ width: '100%' }} onClick={selectChildMerchant}>
                {selectedChildMerchant?.name || 'Child Merchant'}
              </Button>
            </Col>
            <Modal
              title="Select Child Merchant"
              open={visibleSelectChildMerchantModal}
              okText="Ok"
              onCancel={closeSelectChildMerchantModal}
              onOk={OkSelectChildMerchantModal}
            >
              <Merchants onSelect={OkSelectChildMerchantModal} />
            </Modal>
          </>
        )}
      </Row>
      <Row>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          {summaryLoading
          && <span>loading... </span>}
        </Col>
      </Row>
      {!summaryLoading && summary && summary.total_transaction_amount !== undefined
      && selectedTransactionType && selectedTransactionStatus
      && (
        <div>
          <br />
          <Row>
            <Col xl={6} lg={6} md={12} sm={12} xs={24}>
              <Card style={{ background: '#f5f5f7' }}>
                <h3>{new Intl.NumberFormat().format(summary.total_count)}</h3>
                <br />
                <h6>TOTAL COUNT</h6>
              </Card>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} xs={24}>
              <Card style={{ background: '#fdfccf' }}>
                <h3>
                  {new Intl.NumberFormat().format(summary.total_transaction_amount)}
                  {' '}
                  {wallet?.currency?.code}
                </h3>
                <br />
                <h6>{selectedTransactionType || ''}</h6>
              </Card>
            </Col>
            <Col xl={6} lg={6} md={12} sm={12} xs={24}>
              <Card style={{ background: '#f5f5f7' }}>
                <h3>
                  {new Intl.NumberFormat().format(summary.total_wallet_amount)}
                  {' '}
                  {wallet?.currency?.code}
                </h3>
                <br />
                <h6>
                  {ledgerAmountDescription}
                </h6>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

TransactionSummary.propTypes = {
  wallet: PropTypes.oneOfType([
    PropTypes.any,
  ]),
  summary: PropTypes.oneOfType([
    PropTypes.any,
  ]),
  summaryLoading: PropTypes.bool,
  isAffiliate: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

TransactionSummary.defaultProps = {
  wallet: null,
  summary: null,
  summaryLoading: false,
  isAffiliate: false,
};

export default TransactionSummary;
